import firebase from "firebase";
import store from "../store";
import VuexEasyFirestore from 'vuex-easy-firestore'

const config = {
  apiKey: "AIzaSyDXpVrI5YFLodHgsDVmgJ0xLDrVgGuQ52Y",
  authDomain: "livebeam-app.firebaseapp.com",
  databaseURL: "https://livebeam-app.firebaseio.com",
  projectId: "livebeam-app",
  storageBucket: "livebeam-app.appspot.com",
  messagingSenderId: "270419407895",
  appId: "1:270419407895:web:b681c5555987cf47"
};

//export default firebase;

export const fire = firebase.initializeApp(config);

const auth = fire.auth();

export const db = fire.firestore();
export const FieldValues = fire.firestore.FieldValues;
export const storage = fire.storage();



/**
 * vuex modules
 * @param {*} modules 
 */
export const createFirestoreModules = (modules)=>(
  VuexEasyFirestore(
    modules,
    {logging: true, FirebaseDependency: firebase}
  )
)

db.enablePersistence({synchronizeTabs:true}).then(()=>console.log("ok")).catch((e)=>alert(e)); 

export default {
  install: (Vue, options) => {

    const { TimeStamp, GeoPoint, Array } = firebase.firestore;

    Vue.prototype.$db = db;
    Vue.prototype.$fieldValues = FieldValues;
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        return await auth.signInWithEmailAndPassword(username, pass);
      },
      signup: async (username, pass) => {
        return await auth.createUserWithEmailAndPassword(username, pass);
      },      
      logout: async () => {
        await auth.signOut();
      }
    };
    auth.onAuthStateChanged(user => {
      if(user) {
        console.error("auth changed");
        try {
        store.dispatch('userData/openDBChannel').catch((e)=>{
          console.log("userdata/open shit dispatched called with error");
          console.log(e);
        });
        store.commit("application/setUser", user);            

        store.dispatch('events/openDBChannel',{
          where: [["owner", "==", "{userId}"]]
        }).catch((e)=>{
          console.log("dispatched called with error");
          console.log(e);
        });
      }catch(e) {
        
      }
      }
      /*store.commit("application/setUser", user);            
      if(!user) {          
          router.push("/login");
      }else {
        store.dispatch("application/getProfile", {$db: db, uid: user.uid});
      }*/
    });
  }
};
